<template>
    <div class="action-td">
        <button class="btn btn-sm btn-primary" @click="editStoreUser">
            <a-icon icon="Edit" />
            <span class="ml-1"> Edytuj </span>
        </button>
        <store-users-delete-btn :login="login" :id="id" />
    </div>
</template>

<script>
import StoreUsersDeleteBtn from './StoreUsersDeleteBtn'

export default {
    name: 'StoreUsersEditBtn',
    components: { StoreUsersDeleteBtn },
    props: {
        login: {
            type: String
        },
        id: {
            type: Number,
            required: true
        },
        userAlias: {
            type: String
        },
        userPermissions: {
            type: Array,
            required: true
        }
    },
    methods: {
        editStoreUser() {
            this.$store.dispatch('openModal', {
                component: 'EditStoreUser',
                args: {
                    login: this.login,
                    id: this.id,
                    userAlias: this.userAlias,
                    permissions: this.userPermissions
                }
            })
        }
    }
}
</script>
